import { createGlobalStyle } from 'styled-components';
import SpaceGrotesk from '../../fonts/SpaceGrotesk.woff2';
import BrandonGroteskMed from '../../fonts/BrandonGrotesque-Medium.woff2';
import BrandonGroteskReg from '../../fonts/BrandonGrotesque-Regular.woff2';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
    @font-face {
    font-family: 'Brandon Grotesk';
    src: url(${BrandonGroteskReg}) format('woff2');
        font-weight: normal;
    }
    @font-face {
    font-family: 'Brandon Grotesk';
    src: url(${BrandonGroteskMed}) format('woff2');
        font-weight: 300;
    }

    @font-face {
    font-family: 'Space Grotesk';
    src: url(${SpaceGrotesk}) format('woff2')
    }    

    body{
        overflow-x: hidden;
        margin: 0; 
        padding: 0; 
        box-sizing: border-box; 
        background-color: ${theme.common.white};
    }

    ul,ol {
        list-style-type: none;
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
        font-size: 1.2rem;
        color: ${theme.common.black};
    }

    h1 {
        margin: 20px 0px 20px 0px;
        font-weight: 300;
        font-family: 'Brandon Grotesk', sans-serif;
        font-size: 4rem;
        color: ${theme.common.white};
        @media only screen and (max-width: 500px){
            font-size: 3rem;
        }
    }
    h2 {
        margin: 0px 0px 0px 0px;
        font-family: 'Brandon Grotesk', sans-serif;
        font-size: 3.75rem;
        font-weight: 300;
        color: ${theme.common.black};
        @media only screen and (max-width: 500px){
            font-size: 2.5rem;
        }
    }
    h3 {
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
        margin: 30px 0px 40px 0px;
        font-size: 2.2rem;
        color: ${theme.common.grey};
        @media only screen and (max-width: 500px){
            font-size: 1.5rem;
        }
    }
    h4 {
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
        font-size: 2.2rem;
        color: ${theme.common.black};
        @media only screen and (max-width: 500px){
            font-size: 1.5rem;
        }
    }
    h5 {
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
        font-size: 1.8rem;
        color: ${theme.common.black};
    }
    h6 {
        font-family: 'Brandon Grotesk', sans-serif;
        margin: 0;
        font-weight: normal;
        font-size: 1.2rem;
        color: ${theme.common.black};
    }
    p {
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
        font-size: 1.2rem;
        color: ${theme.common.black};
    }
    button {
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
    }
    a {
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
    }
    label{
        font-family: 'Brandon Grotesk', sans-serif;
        font-weight: normal;
        font-size: 1.2rem;
        color: ${theme.common.black};
    }
    #gatsby-focus-wrapper:nth-child(2){
        display:none;
    }
`;

export default GlobalStyles;
